define.alias("shared/utils/object-methods/object-snake-to-camel", "auth/utils/object-methods/object-snake-to-camel");